import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import LoadingDots from "../LoadingDots/LoadingDots";
import "./Overlay.scss";

interface IOverlayProps {
	"data-testid"?: string;
	line1?: string;
	line2?: string;
	enableDotAnimation?: boolean;
}

const Overlay: FC<IOverlayProps> = (props) => {
	const { t } = useTranslation();
	const line1 = props.line1 ?? t("overlay.sendingOrder");
	const line2 = props.line2 ?? t("overlay.dontClose");
	const enableDotAnimation = props.enableDotAnimation ?? false;

	const renderLine1 = () => {
		if (!enableDotAnimation) {
			return line1;
		}

		// Check if line1 ends with "..." and extract text without dots
		const endsWithDots = line1?.endsWith("...");

		if (endsWithDots) {
			const textWithoutDots = line1.replace(/\.{1,3}$/, "");

			return <LoadingDots text={textWithoutDots} />;
		}

		return line1;
	};

	return (
		<div data-testid={props["data-testid"] ?? "Overlay"} className={"OverlayContainer"}>
			<div className="OverlayBG" />
			<div className="OverlayInfo">{renderLine1()}</div>
			<div className="OverlayInfo">{line2}</div>
		</div>
	);
};

export default React.memo(Overlay);
